import { memo } from 'react'

type colorType = 'default' | 'danger'

const CheckCircleComponent = ({
  color,
  checked = false,
}: {
  color?: colorType
  checked?: boolean
}) => {
  let className: string
  switch (color) {
    case 'danger':
      className = 'fill-danger'
      break
    default:
      className = 'fill-white'
  }

  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect className="fill-white" x="2" y="2" width="21" height="21" rx="10" />
      {checked && (
        <path
          className={className}
          d="M12.5 2.34375C6.8999 2.34375 2.34375 6.8999 2.34375 12.5C2.34375 18.1001 6.8999 22.6562 12.5 22.6562C18.1001 22.6562 22.6562 18.1001 22.6562 12.5C22.6562 6.8999 18.1001 2.34375 12.5 2.34375ZM17.7856 9.09619L11.2231 16.9087C11.1512 16.9944 11.0616 17.0637 10.9605 17.1118C10.8594 17.1599 10.7491 17.1857 10.6372 17.1875H10.624C10.5145 17.1875 10.4062 17.1644 10.3062 17.1198C10.2062 17.0752 10.1167 17.0101 10.0435 16.9287L7.23096 13.8037C7.15953 13.728 7.10397 13.6387 7.06753 13.5411C7.0311 13.4436 7.01453 13.3398 7.0188 13.2357C7.02307 13.1317 7.04809 13.0296 7.0924 12.9353C7.1367 12.8411 7.1994 12.7567 7.27679 12.687C7.35419 12.6174 7.44473 12.5639 7.54308 12.5298C7.64144 12.4956 7.74564 12.4814 7.84954 12.4881C7.95345 12.4948 8.05497 12.5222 8.14814 12.5687C8.24131 12.6152 8.32425 12.6798 8.39209 12.7588L10.6035 15.2158L16.5894 8.09131C16.7236 7.93607 16.9136 7.83991 17.1182 7.82361C17.3228 7.8073 17.5256 7.87217 17.6827 8.00418C17.8399 8.1362 17.9388 8.32475 17.958 8.52909C17.9773 8.73343 17.9154 8.93714 17.7856 9.09619V9.09619Z"
        />
      )}
    </svg>
  )
}

export const CheckCircle = memo(CheckCircleComponent, (prev, next) => {
  return !(prev.checked !== next.checked)
})
